<template>
  <path
    opacity="0.5"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.25 20V17H4.75V20C4.75 20.1381 4.86193 20.25 5 20.25H11C11.1381 20.25 11.25 20.1381 11.25 20V17H12.75V20C12.75 20.9665 11.9665 21.75 11 21.75H5C4.0335 21.75 3.25 20.9665 3.25 20Z"
    fill="#3769D6"
  />
  <path
    opacity="0.5"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M20.75 4L20.75 7.5L19.25 7.5L19.25 4C19.25 3.86193 19.1381 3.75 19 3.75L13 3.75C12.8619 3.75 12.75 3.86193 12.75 4L12.75 7.5L11.25 7.5L11.25 4C11.25 3.0335 12.0335 2.25 13 2.25L19 2.25C19.9665 2.25 20.75 3.0335 20.75 4Z"
    fill="#3769D6"
  />
  <rect x="2" y="7" width="4" height="10" rx="1" fill="#3769D6" />
  <rect x="10" y="7" width="4" height="10" rx="1" fill="#3769D6" />
  <rect x="18" y="7" width="4" height="10" rx="1" fill="#3769D6" />
</template>
